<script>
  export let value;
  export let lang = undefined;
</script>

<div class='live-standings-element'
  class:live-standings-element-first={value.position === 1}
  class:live-standings-element-second={value.position === 2}
  class:live-standings-element-third={value.position === 3}>

    <i class='live-standings-element-medal fa-solid fa-medal'/>

    <a href='./#/teams/{value.code}' class='live-standings-element-label'> {value.name[lang]} </a>

    <img class='live-standings-element-flag' src='img/static/flag/{value.flag}.svg' alt='{value.name.en} flag'/>
</div>

<style>
  .live-standings-element {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;

    width: 295px;
    height: 20px;

    font-weight: 550;
  }

  .live-standings-element-medal {
    display: flex;
    justify-content: center;
    align-items: center;

    width: calc(16px / 3 * 4);
    height: 16px;

    border-radius: var(--radius-sm);

    font-size: 12px;

    color: var(--grey-1);
  }

  .live-standings-element-label {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;

    text-align: center;
    text-decoration: underline;
    text-decoration-thickness: 1.5px;
    text-decoration-color: transparent;

    color: inherit;

    transition: text-decoration-color 0.25s ease-in-out;
  }

  .live-standings-element-label:hover {
    text-decoration-color: var(--black);
  }

  .live-standings-element-flag {
    height: 16px;

    border-radius: var(--radius-sm);
  }

  .live-standings-element-first .live-standings-element-medal {
    background: #D4AF37;
  }

  .live-standings-element-second .live-standings-element-medal {
    background: #C0C0C0;
  }

  .live-standings-element-third .live-standings-element-medal {
    background: #CD7F32;
  }

  :global(body.dark) .live-standings-element-medal {
    color: var(--grey-8);
  }

  :global(body.dark) .live-standings-element-label:hover {
    text-decoration-color: var(--grey-3);
  }

  :global(body.dark) .live-standings-element-flag {
    filter: brightness(88%);
  }
</style>
